import { unref, watch } from 'vue'
import { useTitle as usePageTitle } from '@vueuse/core'
import { useRouter } from 'vue-router'
import { useI18n } from '@/hooks/web/useI18n'
import { useGlobSetting } from '@/hooks/setting'
import { useLocaleStore } from '@/store/modules/locale'

import { REDIRECT_NAME } from '@/router/constant'
import { useUserStore } from '@/store/modules/user'

/**
 * Listening to page changes and dynamically changing site titles
 */
export function useTitle() {
  const { title } = useGlobSetting()
  const userStore = useUserStore()
  const titleNew = userStore?.getUserInfo?.tenantRespVO?.name ?? title
  const { t } = useI18n()
  const { currentRoute } = useRouter()
  const localeStore = useLocaleStore()

  const pageTitle = usePageTitle()

  watch(
    [() => currentRoute.value.path, () => localeStore.getLocale],
    () => {
      const route = unref(currentRoute)

      if (route.name === REDIRECT_NAME)
        return

      const tTitle = t(route?.meta?.title)
      pageTitle.value = tTitle ? ` ${tTitle} - ${titleNew} ` : `${titleNew}`
    },
    { immediate: true },
  )
}
